import axios, { certisDspAxiosInstance } from 'services/api/axios';
import { CampaignMetrics, Dimension, Metrics } from '../types/dashboard';

export default {
  getDimensionsList: async (queryString?: string): Promise<Dimension[]> => {
    const response = await axios.get(queryString ? `/dashboard/dimensions?${queryString}` : '/dashboard/dimensions');

    return response.data;
  },
  getMetrics: async (queryString?: string): Promise<{ current: Metrics[] }> => {
    const response = await axios.get(queryString ? `/dashboard/metrics?${queryString}` : '/dashboard/metrics');

    return response.data;
  },
  getCampaignMetrics: async (queryString: string): Promise<CampaignMetrics[]> => {
    const response = await certisDspAxiosInstance.get(`/campaigns/metrics/?${queryString}`);

    return response.data;
  },
};
